import Text from '../text/Text';
import './styles.css'

export const PartnerCard = ({ partner }) => {
    const { id, image, category, name, description } = partner;

    return (
        <div className='partner'>
            <img src={image} alt="partner-logo" />
            <Text as="p" fontSize={20}><strong>{name}</strong><br />{category}</Text>
            <Text as="p" variant='grey'>{description}</Text>
        </div>
    );
};